import { useMutation } from "@apollo/client";
import React from "react";

import QUERY from "../../utils/service/query";
interface PropsType {
	item: {
		id: string;
		title: string;
	};
}

const Chip: React.FC<PropsType> = ({ item }) => {
	const [deleteReason] = useMutation(QUERY.REPORTS.DELETE_REASON);

	return (
		<div
			className="d-flex align-items-center justify-content-center p-2 mt-2 "
			style={{
				width: "170px",
				minWidth: "170px",
				maxHeight: "32.4px",
				border: "1px solid var(--falcon-primary)",
				borderRadius: "0.2rem",
				color: "var(--falcon-primary)",
				backgroundColor: "#edf2f9",
				position: "relative",
				marginRight: "8px",
			}}>
			<span
				className=""
				style={{
					position: "absolute",
					top: "-2px",
					right: "4px",
					fontSize: "10px",
					fontWeight: "bold",
					cursor: "pointer",
				}}
				onClick={() => {
					deleteReason({
						variables: { id: item.id },
						refetchQueries: [
							{ query: QUERY.REPORTS.GET_REASONS, variables: { page: 1 } },
						],
					});
				}}>
				x
			</span>

			<h6 className="m-0 text-primary" style={{ fontSize: "12px" }}>
				{item.title}
			</h6>
		</div>
	);
};

export default Chip;
